import { ReactNode } from "react";

interface SidebarSectionProps {
    title?: string;
    children: ReactNode;
    collapsed?: boolean;
}

const SidebarSection = ({ title, children, collapsed }: SidebarSectionProps) => (
    <div className="mb-3">
        {title && !collapsed && (
            <h3
                className="px-1.5 mb-1.5 pt-3 text-xs font-medium text-muted-foreground whitespace-nowrap"
            >
                {title}
            </h3>
        )}
        <div className="space-y-0.5">{children}</div>
    </div>
);

export default SidebarSection;
